import './location.scss';

export default () => {
};
